//
//
//
//
//
//
//
//
//

import _ from 'underscore'
import DIC from '@/index/dictionary'
export default {
  data: function() {
    let status = (this.$route.query.status !== undefined) ? parseInt(this.$route.query.status) : 0
    return {
      search: {
        q: undefined,
        status: status
        // status: 2
      },
      status: status,
      page: {
        pageNo: 1,
        pageSize: 20,
        total: 0
      },
      table: [],
      tabsOptions: DIC.ORDER_SEARCH_STATUS.concat([
        { value: -1, label: '全部' }
      ]),
      loading: false
    }
  },
  watch: {
    'status': {
      handler (val) {
        if (val !== undefined && val !== this.search.status) {
          this.search.status = val
          this.page.pageNo = 1
        }
      }
    },
    'search.status': {
      handler (val) {
        this.handleLoadTableData()
      },
      immediate: true
    }
  },
  components: {
    PageHeader: () => import('./components/PageHeader/index.vue'),
    PageMain: () => import('./components/PageMain/index.vue')
  },
  mounted () {
  },
  methods: {
    handleLoadTableData () {
      return new Promise((resolve, reject) => {
        this.loading = true
        let data = _.extend({}, this.search, _.pick(this.page, 'pageNo', 'pageSize'))
        // console.log('data', data)
        this.$axios.get('/mtea/store/admin/order/list', { params: data }).then(res => {
          let list = []
          console.log(JSON.stringify(res.records))
          _.each(res.records, (t, i, l) => {
            let item = _.extend({
              isOrderItem: 1,
              selected: false,
              goodsInfo: {
                name: `订单编号: ${t.orderNo}  下单时间: ${t.createTime}`,
                goodsExtra: {}
              }
            }, _.pick(t, "orderId", "orderNo", "createTime", "updateTime"))
            list.push(item)
            _.each(t.items, (m, j, k) => {
              if (m.goodsExtra) {
                m.goodsExtra = JSON.parse(m.goodsExtra)
                if (m.goodsExtra.images) {
                  m.goodsExtra.images = m.goodsExtra.images.split(',')
                }
              }
              let n = _.extend({goodsInfo: m, isOrderItem: 0},t)
              if (j === 0 ) {
                n.isMainGoods = 1
              } else {
                n.isMainGoods = 0
              }
              list.push(n)
            })
          })
          this.page.total = res.total
          this.table = list
        }).finally(() => {
          this.loading = false
          resolve()
        })
      })
    }
  }
}
